import { useTranslation } from "react-i18next";

export default function CTABanner() {
  const { t } = useTranslation("velux-reparatie");

  return (
    <section className="bg-brand-blue py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 text-center">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-white tracking-tight mb-6 md:mb-8">
          {t("ctaBanner.h2")}
        </h2>
        <a
          href="tel:+31407987470"
          className="inline-flex items-center gap-2 font-geist font-bold text-sm md:text-base bg-brand-yellow text-brand-text px-6 md:px-8 py-3.5 md:py-4 rounded-full hover:bg-white transition-colors whitespace-nowrap"
        >
          <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
          {t("ctaBanner.cta")}
        </a>
      </div>
    </section>
  );
}